module.exports = __webpack_public_path__ + "media/images/stamp-8965b06edee8323a7489152b9937a920.png";